import { store } from '@remote/store'
import axios from 'axios'
import { nanoid } from 'nanoid'
import pkg from '../../package.json'
import { xbaseConfig } from '@remote/api/config'
import { reactive, ref } from 'vue'
import { useEnvStore } from '@remote/store/env'
import global from '@remote/store/constantStore'

/**
 * 全局单例
 */
export class FlowHub {
  availableSlotParams = {
    POSITION_CINEMA_EMPTY: {
      // 后需更改为md5值，保证长度的一致性
      id: `${nanoid()}`,
      slots: [
        {
          id: 'nas_remote_personalmovie_middle_banner',
          accept_source: ['native'],
          accept_landing_type: ['LANDING_CALL_APP'],
          accept_style: [
            'image_above_text_below',
          ],
          accept_event: ['EVENT_IMPRESSION', 'EVENT_CLICK'],
        },
      ],
    },
  }

  // TODO: type
  slotResult = ref<Record<string, any>>({})

  hosts = ['https://api-shoulei-ssl.xunlei.com', 'https://test-api-shoulei-ssl.xunlei.com']
  
  host = this.hosts[0]

  async getFlowHubSlots (slot: (keyof FlowHub['availableSlotParams'])) {
    const envStore = useEnvStore()
    const result = await axios.post(`${this.host}/flowhub/v1/slots:batchGet`, {
      ...this.availableSlotParams[slot],
    }, {
      headers: {
        // 'user-id': store.state.user?.userID ?? '',
        'x-client-id': xbaseConfig.clientId,
        'x-peer-id': store.state.curDeviceRunner.target,
        'x-device-id': global.deviceID,
      },
    })
    if (result.data) {
      this.slotResult.value[slot] = reactive(result.data)
    }
  }

  async reportFlowHub (url: string, params?: Record<string, any>) {
    // 测试环境兼容
    if (location.href.startsWith('https') && url.startsWith('http://test.api-shoulei-ssl.xunlei.com')) {
      url = url.replace('http://test.api-shoulei-ssl.xunlei.com', 'https://test-api-shoulei-ssl.xunlei.com')
    }
    axios.get(url, {
      headers: {
        // 'user-id': store.state.user?.userID ?? '',
        'x-client-id': xbaseConfig.clientId,
        'x-peer-id': store.state.curDeviceRunner.target,
        'x-device-id': global.deviceID,
      },
      params,
    }).catch()
  }
}

export const flowHubInstance = new FlowHub()